export default __webpack_public_path__ + "static/media/crossSymbol.8f7a2333.svg";